/* eslint-disable no-param-reassign */
export default {
    install: function install(app, r15Svc, store) {
        app.$r15Svc = r15Svc;
        store.$r15Svc = r15Svc;
        app.config.globalProperties.$r15Svc = r15Svc;
    },
};
